import { render, staticRenderFns } from "./Pendanaan.vue?vue&type=template&id=f873e574&scoped=true"
import script from "./Pendanaan.vue?vue&type=script&lang=js"
export * from "./Pendanaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f873e574",
  null
  
)

export default component.exports